import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  DOCUMENT
} from '@angular/core';


@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective implements OnInit, OnDestroy, OnChanges {
  @Input() attachOutsideOnClick: boolean = false;
  /** CSS selector string for elements that should NOT trigger the clickOutside event.
   *  Example: [exclude]="'#mobile-collapse, .navbar-logo'"
   */
  @Input() exclude: string = '';
  @Output() clickOutside: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(
    @Inject(DOCUMENT) private _document /*: HTMLDocument*/,
    private _el: ElementRef) {
    this._initOnClickBody = this._initOnClickBody.bind(this);
    this._onClickBody = this._onClickBody.bind(this);
  }

  ngOnInit() {
    this._init();
  }

  ngOnDestroy() {
    if (this.attachOutsideOnClick) {
      this._el.nativeElement.removeEventListener('click', this._initOnClickBody);
    }

    this._document.body.removeEventListener('click', this._onClickBody);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['attachOutsideOnClick'] &&
      changes['attachOutsideOnClick'].previousValue !== changes['attachOutsideOnClick'].currentValue) {
      this._init();
    }
  }

  private _init() {
    if (this.attachOutsideOnClick) {
      this._el.nativeElement.addEventListener('click', this._initOnClickBody);
    } else {
      this._initOnClickBody();
    }
  }

  private _initOnClickBody() {
    this._document.body.addEventListener('click', this._onClickBody);
  }

  private _isExcluded(target: EventTarget | null): boolean {
    if (!this.exclude || !target) {
      return false;
    }
    try {
      // Support comma-separated list of selectors, e.g. "#mobile-collapse, .navbar-logo"
      const selectors = this.exclude.split(',').map(s => s.trim()).filter(Boolean);
      return selectors.some(selector => {
        const el = this._document.querySelector(selector);
        return el && (el === target || el.contains(target as Node));
      });
    } catch (e) {
      return false;
    }
  }

  private _onClickBody(e: Event) {
    // Don't emit if the click was inside this element OR inside an excluded element
    if (!this._el.nativeElement.contains(e.target) && !this._isExcluded(e.target)) {
      this.clickOutside.emit(e);

      if (this.attachOutsideOnClick) {
        this._document.body.removeEventListener('click', this._onClickBody);
      }
    }
  }
}